export type ContactDialogMessages = {
  deleteContactDialogTitle: string;
  deleteContactDialogContent: string;
  deleteContactDialogCancel: string;
  deleteContactDialogConfirm: string;
  deleteContactSuccess: string;
  deleteContactError: string;
};

export const CONTACT_DIALOG_MESSAGES: ContactDialogMessages = {
  deleteContactDialogTitle: "Excluir Contato",
  deleteContactDialogContent: "Tem certeza de que deseja excluir este contato?",
  deleteContactDialogCancel: "Cancelar",
  deleteContactDialogConfirm: "Confirmar",
  deleteContactSuccess: "Contato deletado com sucesso.",
  deleteContactError: "Erro ao deletar o contato.",
};
